import { lazy } from 'react';
import { authRoles } from 'src/app/auth';

import { Navigate } from 'react-router-dom';

const ProfileStuff = lazy(() => import('./tabs/ProfileTabs/ProfileStuff'));
const Attendance = lazy(() => import('./tabs/ProfileTabs/Attendance'));
const ProfileProjects = lazy(() => import('./tabs/ProfileTabs/ProfileProjects'));
const ProfileSkills = lazy(() => import('./tabs/ProfileTabs/ProfileSkills'));
const ProfileWorkLoad = lazy(() => import('./tabs/ProfileTabs/ProfileWorkLoad'));
const MyAbsenceAsks = lazy(() => import('./tabs/ProfileTabs/MyAbsenceAsks'));
const MyAppointments = lazy(() => import('./tabs/ProfileTabs/MyAppointments'));
const ProfileSessions = lazy(() => import('./tabs/ProfileTabs/ProfileSessions'));
const ProfileApp = lazy(() => import('./ProfileApp'));

const profileAppConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.user,
  routes: [
    {
      path: 'apps/profile',
      element: <ProfileApp />,
      children: [
        {
          path: '',
          element: <Navigate to={'/apps/profile/profile-detail'} />,
        },
        {
          path: 'profile-detail',
          element: <ProfileStuff />,
        },
        {
          path: 'attendance',
          element: <Attendance />,
        },
        {
          path: 'my-absence-asks',
          element: <MyAbsenceAsks />,
        },
        {
          path: 'projects',
          element: <ProfileProjects />,
        },
        {
          path: 'skills',
          element: <ProfileSkills />,
        },
        {
          path: 'workload',
          element: <ProfileWorkLoad />,
        },
        {
          path: 'appointments',
          element: <MyAppointments />,
        },
        {
          path: 'profile-sessions',
          element: <ProfileSessions />,
        }
      ],
    },
  ],
};

export default profileAppConfig;
